module.exports = __webpack_public_path__ + "static/media/phone.f84a607a.svg";